<template>
  <div class="drawer" v-if="curUser">
    <div class="user-avatar">
      <div v-if="curUser" class="avatar-details">
        <h5>{{ curUser.name}}</h5>
        <p>{{ curUser.email }}</p>
        <p>{{ curUser.level }}</p>
      </div>
    </div>
    <div class="routes">
      <ul>
        <li v-if="isUpdateAvailable">
          <a @click="updateApp">
            <div class="icon-box">
              <font-awesome-icon class="icon text-info" icon="fa-solid fa-exclamation-circle"/>
            </div>
            <div class="d-flex flex-column text-center">
              Update Is Available
              <span class="text-sm" @click="updateApp">Click to Update</span>
            </div>
          </a>
        </li>

        <li>
          <router-link @click.native="back" :to="{ name : 'dashboard' }">
            <div class="icon-box">
              <font-awesome-icon class="icon" icon="chart-simple"/>
            </div>
            Dashboard
          </router-link>
        </li>

        <li>
          <router-link @click.native="back" :to="{ name : 'kyc-signups' }">
            <div class="icon-box">
              <font-awesome-icon class="icon" icon="user-check"/>
            </div>
            KYC Signups
          </router-link>
        </li>

        <li v-if="userLevel === 'SUPERADMIN'">
          <router-link @click.native="back" :to="{ name : 'kazang-agents' }">
            <div class="icon-box">
              <font-awesome-icon class="icon" icon="users"/>
            </div>
            Kazang Agents
          </router-link>
        </li>

        <li>
          <router-link @click.native="back" :to="{ name : 'paymentProcessing-blocking' }">
            <div class="icon-box">
              <font-awesome-icon class="icon" icon="gears"/>
            </div>
            Payment Processing
          </router-link>
        </li>

        <li>
          <router-link @click.native="back" :to="{ name : 'payment-wallet' }">
            <div class="icon-box">
              <font-awesome-icon class="icon" icon="wallet"/>
            </div>
            Payment Wallet
          </router-link>
        </li>

        <li v-if="userLevel !== 'SUPERADMIN'">
          <router-link @click.native="back" :to="{ name : 'form-management' }">
            <div class="icon-box">
              <font-awesome-icon class="icon" icon="file-pen"/>
            </div>
            Form Management
          </router-link>
        </li>

        <li>
          <router-link @click.native="back" :to="{ name : 'settings' }">
            <div class="icon-box">
              <font-awesome-icon class="icon" icon="gear"/>
            </div>
            Settings
          </router-link>
        </li>

        <li>
          <a style="cursor: pointer" @click="logout">
            <div class="icon-box">
              <font-awesome-icon class="icon" icon="arrow-right-from-bracket"/>
            </div>
            Log out
          </a>
        </li>
      </ul>
    </div>
  </div>

</template>

<script>
import { Storage } from '@/Services/Storage'
import { faWallet, faGears, faChartLine, faFilePen } from '@fortawesome/free-solid-svg-icons'
import { library } from '@fortawesome/fontawesome-svg-core'

library.add(faWallet, faGears, faChartLine, faFilePen)

export default {
  name: "NavigationDrawer",
  props: {
    close: {
      type: Function,
      required: true,
    }
  },
  computed: {
    isUpdateAvailable(){
      return this.$store.getters.getLoadingState;
    },
    curUser(){
      let user = JSON.parse(localStorage.getItem('user'))
      if (!user) return this.$router.push({ name : 'login' })
      return user;
    },
    isAdmin() {
      return Storage.isAdmin();
    },
    userLevel() {
      return this.$store.getters.userLevel;
    },
    isSuperAdmin() {
      return Storage.isSuperAdmin();
    }
  },
  methods: {
    setAuthStatus(state, status) {
      state.isAuthenticated = status;
    },
    
    back() {
      if (this.close) {
        this.close();
      } else {
        console.log("Close not defined")
      }
    },
    logout() {
      return Swal.fire({
        icon: 'warning',
        title: 'Are you sure?',
        text: 'You will be logged out!',
        showCloseButton: true,
        showCancelButton: true,
      }).then((res) => {
        if (res.isConfirmed) {
          this.$store.commit('setAuthStatus', false);
          localStorage.clear();
          this.$router.push({ name: 'login' });
        }
      });
    },
    updateApp(){
      this.back();
      this.$store.commit(`setUpdateAvailability`,false)
      return window.location.reload(true);
    },
  }
}
</script>

<style lang="scss" scoped>
.disabled {
  pointer-events: none;
  display: none;
}

.drawer {
  width: 100%;
  background: white;
  height: 100%;
  overflow-y: auto;

  .routes {
    ul {
      list-style: none;
      margin: 0;
      padding: 0;

      li {
        padding: 0;

        a {
          height: 50px;
          display: flex;
          flex-direction: row;
          align-items: center;
          font-weight: 600;
          padding-left: 10px;
          text-decoration: none;
          color: #1c1c1c;

          .icon-box {
            width: 35px;
            margin-right: 10px;
            display: flex;
            justify-content: center;

            .icon {
              font-size: 25px;
              color: #34373C;
            }
          }

          &:hover, &.router-link-exact-active {
            background: #f1f1f1;

            color: #04121b;
            font-weight: 700;

            .icon-box {
              .icon {
                color: #04121b;
              }
            }
          }
        }
      }
    }
  }

  .user-avatar {
    display: inline-flex;
    width: 100%;
    background: url('/src/assets/img/KycBanner.png') fixed;
    background-size: cover;
    color: white;
    min-height: 140px;
    background-color: rgba(50, 70, 80, 0.7);
    background-blend-mode: soft-light;

    .avatar {
      background: #40434A;
      min-width: 80px;
      width: 80px;
      height: 80px;
      border-radius: 50%;
    }

    .avatar-details {
      width: 100%;
      padding: 5px 5px 5px 10px;
      display: flex;
      flex-direction: column;
      align-items: start;
      justify-content: center;

      h5, p {
        margin: 0;
      }

      p {
        font-size: 15px;
        color: #ffffff;
        font-weight: 400;

        &:nth-child(3) {
          color: #c0d9ef;
          font-weight: 600;
        }
      }

    }
  }
}

ul {
  text-align: center;

  span {
    font-family: "Inter", sans-serif;
    font-size: 15px;
    font-weight: bold;
  }
}

.last-upd {
  font-weight: bold;
}
</style>
